import { MenuItemProps } from 'antd';
import React, { FC, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, useParams } from 'react-router-dom';
import styled from 'styled-components';
import { ProjectTemplateSpaceTab } from 'data/templates/projects';
import { DocumentTitle } from '../../commons';
import { Menu } from './styled';
import { generateTabMenuKey } from './utils';

export const TitleContainer = styled.div`
  width: 100%;
  display: inline-flex;
  align-items: center;

  svg,
  .ant-image {
    margin-right: var(--spacing-03);
    flex-shrink: 0;
    color: var(--blue-60);

    &-img {
      display: block;
    }
  }
`;

export const Container = styled.span`
  width: calc(100% - var(--spacing-05));

  .add-button,
  .more-actions {
    opacity: 0;
    transition: opacity 50ms ease-in;
  }
  .add-button:focus-within,
  .more-actions:focus-within {
    opacity: 1;
  }

  a {
    width: 100%;
  }

  &:hover {
    .add-button,
    .more-actions {
      opacity: 1;
    }
  }
`;

type SpaceTabMenuItemTypes = MenuItemProps & {
  spaceId: number;
  spaceTab: AtLeast<
    ProjectTemplateSpaceTab,
    'spaceTabId' | 'spaceTabTitle' | 'spaceTabType'
  >;
  showNewTab?: boolean;
  dataCy: string;
};

export const SpaceTabMenuItem: FC<SpaceTabMenuItemTypes> = ({
  spaceTab,
  spaceId,
  showNewTab,
  dataCy,
  ...rest
}: SpaceTabMenuItemTypes) => {
  const { spaceTabId, spaceTabTitle } = spaceTab;

  const { templateId } = useParams<{ templateId: string }>();

  const stringifiedTabId = spaceTabId.toString();

  const iconSrc = useMemo(() => {
    if (Array.isArray(spaceTab.metaData?.links?.icon)) {
      return spaceTab.metaData?.links?.icon[0]?.href;
    }

    return undefined;
  }, [spaceTab]);

  return (
    <Menu.Item
      key={generateTabMenuKey(spaceId, stringifiedTabId)}
      data-cy={dataCy}
      {...rest}
    >
      <Container>
        <Link
          to={`/templates/projects/${
            templateId || 'new'
          }/spaces/${spaceId}/tabs/${spaceTabId}`}
          title={spaceTabTitle ?? '-'}
        >
          {showNewTab ? (
            <FormattedMessage id="space_tab.new_tab" />
          ) : (
            <TitleContainer>
              <DocumentTitle title={spaceTabTitle ?? '-'} iconSrc={iconSrc} />
            </TitleContainer>
          )}
        </Link>
      </Container>
    </Menu.Item>
  );
};
